/**
 *
 * Asynchronously loads the component for VerifyEmail
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
export const ErrorHandler = loadable(() => import('./errorHandling'));
